export default __webpack_public_path__ + "static/media/LinkedIn.307e13c8.png";